<!-- Item wrapper -->
<div
    class="cb-horizontal-navigation-item-wrapper"
    [class.cb-horizontal-navigation-item-has-subtitle]="!!item.subtitle"
    [ngClass]="item.classes?.wrapper">

    <!-- Item with an internal link -->
    <div
        class="cb-horizontal-navigation-item text-lg font-normal"
        *ngIf="item.link && !item.externalLink && !item.function && !item.disabled"
        [ngClass]="{'cb-horizontal-navigation-item-active-forced': item.active}"
        [routerLink]="[item.link]"
        [routerLinkActive]="'cb-horizontal-navigation-item-active'"
        [skipLocationChange]="hiddenPath"
        (click)="putCodeInWS(item)"
        [routerLinkActiveOptions]="isActiveMatchOptions">
        <ng-container *ngTemplateOutlet="itemTemplate"></ng-container>
    </div>

    <!-- Item with an external link -->
    <a
        class="cb-horizontal-navigation-item text-lg font-normal"
        *ngIf="item.link && item.externalLink && !item.function && !item.disabled"
        [href]="item.link"
        [skipLocationChange]="hiddenPath"
        
        [target]="item.target || '_self'">
        <ng-container *ngTemplateOutlet="itemTemplate"></ng-container>
    </a>

    <!-- Item with a function -->
    <div
        class="cb-horizontal-navigation-item text-lg font-normal"
        *ngIf="!item.link && item.function && !item.disabled"
        [ngClass]="{'cb-horizontal-navigation-item-active-forced': item.active}"
        [skipLocationChange]="hiddenPath"
        (click)="item.function(item)">
        <ng-container *ngTemplateOutlet="itemTemplate"></ng-container>
    </div>

    <!-- Item with an internal link and function -->
    <div
        class="cb-horizontal-navigation-item text-lg font-normal"
        *ngIf="item.link && !item.externalLink && item.function && !item.disabled"
        [ngClass]="{'cb-horizontal-navigation-item-active-forced': item.active}"
        [routerLink]="[item.link]"
        [routerLinkActive]="'cb-horizontal-navigation-item-active'"
        [routerLinkActiveOptions]="isActiveMatchOptions"
        [skipLocationChange]="hiddenPath"
        (click)="item.function(item)">
        <ng-container *ngTemplateOutlet="itemTemplate"></ng-container>
    </div>

    <!-- Item with an external link and function -->
    <a
        class="cb-horizontal-navigation-item text-lg font-normal"
        *ngIf="item.link && item.externalLink && item.function && !item.disabled"
        [href]="item.link"
        [skipLocationChange]="hiddenPath"
        [target]="item.target || '_self'"
        (click)="item.function(item)"
        mat-menu-item>
        <ng-container *ngTemplateOutlet="itemTemplate"></ng-container>
    </a>

    <!-- Item with a no link and no function -->
    <div
        class="cb-horizontal-navigation-item text-lg font-normal"
        *ngIf="!item.link && !item.function && !item.disabled"
        [skipLocationChange]="hiddenPath"
        [ngClass]="{'cb-horizontal-navigation-item-active-forced': item.active}">
        <ng-container *ngTemplateOutlet="itemTemplate"></ng-container>
    </div>

    <!-- Item is disabled -->
    <div
        class="cb-horizontal-navigation-item cb-horizontal-navigation-item-disabled"
        *ngIf="item.disabled">
        <ng-container *ngTemplateOutlet="itemTemplate"></ng-container>
    </div>

</div>

<!-- Item template -->
<ng-template #itemTemplate>

    <!-- Icon -->
    <mat-icon
        class="cb-horizontal-navigation-item-icon color-blue"
        [ngClass]="item.classes?.icon"
        *ngIf="item.icon"
        [svgIcon]="item.icon"></mat-icon>

    <!-- Title & Subtitle -->
    <div class="cb-horizontal-navigation-item-title-wrapper ">
        <div class="cb-horizontal-navigation-item-title text-lg mt-1">
            <span [ngClass]="item.classes?.title">
                {{item.title}}
            </span>
        </div>
        <div
            class="cb-horizontal-navigation-item-subtitle text-hint mb-1"
            *ngIf="item.subtitle">
            <span [ngClass]="item.classes?.subtitle">
                {{item.subtitle}}
            </span>
        </div>
    </div>

    <!-- Badge -->
    <div
        class="cb-horizontal-navigation-item-badge"
        *ngIf="item.badge">
        <div
            class="cb-horizontal-navigation-item-badge-content"
            [ngClass]="item.badge.classes">
            {{item.badge.title}}
        </div>
    </div>

</ng-template>
